import styled from "styled-components";
import {
  PropListItem,
  PropLabel
} from "editor/components/EditorElements/styles";

/**
 * Label container for prop name in edit model
 */
export const CustomPropListItem = styled(PropListItem)`
  flex-direction: column;
`;

export const CustomPropLabel = styled(PropLabel)`
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2px;
`;

export const IconWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 5px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10px;

  .faqCounter {
    width: 100%;
    font-size: 12px;
    margin-bottom: 40px;

    display: flex;
    justify-content: space-between;
  }

  .switch {
    display: flex;
    align-items: center;
    height: 25px;
    padding: 1px 12px 2px;
    background-color: #50aff4;
    border-radius: 20px;
    font-size: 12px;
    color: #fff;
    cursor: pointer;

    :focus {
      outline: none;
    }

    :not(:last-child) {
      margin-right: 10px;
    }

    img {
      margin-right: 5px;
    }
  }
`;




